const DataSource = {

"source-1": 'United Nations Population Division, %%World Population Prospects: The 2017 Revision%% (New York: UN, 2017).',
"source-1-link1": "",
"source-1-link2": "",

"source-2": 'World Health Organization (WHO), %%"Total NCD Mortality Data by Country," Global Health Observatory Data Repository%%, accessed at %%http://www.who.int/gho/ncd/mortality_morbidity/ncd_total/en/%%, on Aug. 30, 2018.',
//"source-2-link1": "http://www.who.int/gho/ncd/mortality_morbidity/ncd_total/en/",
"source-2-link1": "",
"source-2-link2": "",

"source-3": "World Health Organization (WHO), %%Global Health Estimates 2016: Deaths by Cause, Age, Sex, by Country and by Region%%, 2000-2016 (Geneva: WHO, 2018).",
"source-3-link1": "",
"source-3-link2": "",

"source-4": 'World Health Organization (WHO), %%"Risk of Premature Death From the Four Target NCDs Data by Country," Global Health Observatory Data Repository%%, accessed at %%http://apps.who.int/gho/data/view.sdg.3-4-data-ctry?lang=en%%, on Aug. 30, 2018.',
"source-4-link1": "",
"source-4-link2": "",

"source-5": "World Health Organization (WHO) and Centers for Disease Control and Prevention (CDC), %%Global Youth Tobacco Survey (GYTS)%%; Data from country survey results were obtained from the Country Reports and the Fact Sheets accessed at %%https://www.who.int/tobacco/surveillance/gyts/en/%% and %%https://nccd.cdc.gov/GTSSDataSurveyResources/Ancillary/Documentation.aspx?SUID=1&DOCT=1%%, on Aug 31, 2018.",
"source-5-link1": "",
"source-5-link2": "",

"source-6": "World Health Organization (WHO) and Centers for Disease Control and Prevention (CDC), %%Global School-Based Student Health Survey (GSHS)%%; Data from country survey results were obtained from the Country Reports and the Fact Sheets accessed at %%https://www.who.int/ncds/surveillance/gshs/en/%%, and %%https://www.cdc.gov/gshs/index.htm%%, on Aug 31, 2018.",
"source-6-link1": "",
"source-6-link2": "",

"source-7": 'The Health Behaviour in School-Aged Children (HBSC) Research Network and the World Health Organization (WHO) Regional Office for Europe, %%"Health Behaviour in School-Aged Children"%%; Data from each wave of the survey were obtained from the International Report corresponding to each survey accessed at %%http://www.hbsc.org/publications/international/%%, on Aug 31, 2018.',
"source-7-link1": "",
"source-7-link2": "",

"source-8": "Jo Inchley et al., ed. %%Adolescent Obesity and Related Behaviours: Trends and Inequalities in the WHO European Region, 2002-2014. Observations From the Health Behavior in School-Aged Children (HBSC) WHO Collaborative Cross-National Study%% (Copenhagen: WHO Regional Office for Europe, 2017).",
"source-8-link1": "",
"source-8-link2": "",

}

export default DataSource



// WEBPACK FOOTER //
// ./src/data/DataSource.js